import styled from "styled-components";

export const Card = styled.div`
  background-color: #FDFDFE;
  border-radius: 20px;
  box-shadow: 0 20px 60px 0 rgba(79,104,145,0.1);
  -webkit-box-shadow: 0 20px 60px 0 rgba(79,104,145,0.1);
  -moz-box-shadow: 0 20px 60px 0 rgba(79,104,145,0.1);
  padding: 1rem;
  margin-bottom: 1.5rem;
  
  @media (max-width: 992px) {
    padding: 2rem 1rem .5rem;
    margin-bottom: 2.5rem;
  }
`;

export const CardAction = styled.div`
  background-color: #F8F9FA;
  border-radius: 10px;
  width: 100%;
  display: flex;
  margin-top: 2rem;
  padding: .3rem 0;

  div {
    padding: .5rem 0;
    text-align: center;
    width: 50%;

    &:first-child {
      border-left: 1px solid rgba(108, 140, 191, 0.3);
    }
  }

  a.sky-color:hover {
    color: #5c7caf;
  }
`;
